import "./PricePerUnitCellFormula.css";

import Draggable from "react-draggable";
import { useDispatch, useSelector } from "react-redux";

import KsprButton from "components/UI/buttons/KsprButton";
import { copyToClipboard } from "core/clipboard_utils";
import { setFormulaVisible } from "slices/kats";

const PricePerUnitCellFormula = () => {
	const dispatch = useDispatch();
	const formulaRow = useSelector((state) => state.kats.formulaRow);
	if (formulaRow == null) return;

	const { formulaStr, event } = formulaRow;

	if (formulaStr == null) return;
	if (event == null) return;

	return (
		<Draggable handle=".PricePerUnitCellFormulaHeader">
			<div className="PricePerUnitCellFormula" style={{ top: event?.clientY, right: "200px" }}>
				<div className="PricePerUnitCellFormulaHeader">Формула</div>
				<div className="PricePerUnitCellFormulaBody">{formulaStr}</div>
				<div className="PricePerUnitCellFormulaFooter">
					<KsprButton variant="text" label="Копировать" onClick={() => copyToClipboard(formulaStr)} />
					<KsprButton variant="text" label="Закрыть" onClick={() => dispatch(setFormulaVisible(false))} />
				</div>
			</div>
		</Draggable>
	);
};

export default PricePerUnitCellFormula;
